import { render, staticRenderFns } from "./zone.vue?vue&type=template&id=d315059a&scoped=true"
import script from "./zone.js?vue&type=script&lang=js&external"
export * from "./zone.js?vue&type=script&lang=js&external"
import style0 from "./zone.scss?vue&type=style&index=0&id=d315059a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d315059a",
  null
  
)

export default component.exports